// extracted by mini-css-extract-plugin
export default {"line":"line---B9ZjX","text":"text---yezSu"};